// extracted by mini-css-extract-plugin
export var radioInputRow = "z_sz";
export var radioInputColumn = "z_sB";
export var inputOptionRow = "z_r5";
export var inputOptionColumn = "z_r6";